(function() {
    $(document).ready(function() {
        $('.menu-handler').on('click', function() {
            $(this).toggleClass('active');
            $('.menu').toggleClass('active');
        });

        $('.c24-cc-trigger').on('click', function() {
            window.Check24.cookieBanner.c24consent.showConsentScreen();
            return false;
        });
        window.Check24.cookieBanner.init();
    });
})();
